import React from 'react';
import Button from '@material-ui/core/Button';
import Snackbar from '@material-ui/core/Snackbar';
import MuiAlert from '@material-ui/lab/Alert';
import SystemLabel from '../../../../../system/SystemLabel/SystemLabel';

function Alert(props) {
    return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function CustomSnackbar(props) {
    const [state, setState] = React.useState({
        open: false,
        vertical: 'top',
        horizontal: 'center',
    });

    const { vertical = 'bottom', horizontal = 'left', isOpen, toggleSnackbar, autoHideDuration = 5000, status = "success", message } = props;

    const handleClose = () => {
        toggleSnackbar(false)
    };

    return (
        <div>
            <Snackbar
                anchorOrigin={{ vertical, horizontal }}
                key={`${vertical},${horizontal}`}
                open={isOpen}
                onClose={handleClose}
                autoHideDuration={autoHideDuration}
            >
                <Alert onClose={handleClose} severity={status}>
                    <SystemLabel name={message} />
                </Alert>
            </Snackbar>
        </div>
    );
}